import { Box, Button, Flex, Grid, Input, Menu, rem } from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { IconCaretDown, IconSearch } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { repositoryPos } from "../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
import { SaveKeySearch } from "../../common/SaveKeySearch/SaveKeySearch";
import { _localization } from "../../config/location";
import { MessageResponse } from "../../model/MessageResponse";
import { SelectListItemModel } from "../../model/SelectListItem";
import { reportItemSales } from "../../model/TblOrderHeader";

const ReportSerialChild = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<reportItemSales[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //chi nhánh
  // const [dataBranchCode, setDataBranchCode] = useState<SelectListItemModel[]>(
  //   []
  // );
  const userLogin = JSON.parse(localStorage.getItem("userLogin") || "{}");
  //Kho
  const [dataInventory, setDataInventory] = useState<SelectListItemModel[]>([]);
  //Bộ phận
  const [dataDepartment, setDataDepartment] = useState<SelectListItemModel[]>(
    [],
  );

  //chi nhánh
  const [dataBranchCode, setDataBranchCode] = useState<SelectListItemModel[]>(
    [],
  );

  //Khách hàng
  const [dataCustomer, setDataCustomer] = useState<SelectListItemModel[]>([]);
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 1.7 };
  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      Code: "",
      Serial: "",
      ParentSerial: "",
      KeySearch: "",
    },
  });

  const [search, setSearch] = useState({
    Cnids: [], //chi nhánh
    KhoIds: [], //kho
    Bpids: [], //bộ phận
    KHids: [], //khách hàng
  });
  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    try {
      let url = `/api/v1/TblInventorySerialOnHand/get-list-child-serial?Skip=${
        pagination?.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const { Code, Serial, ParentSerial, KeySearch } =
        formSeachInput.getValues();

      if (Code) {
        url += `&Code=${Code}`;
      }
      if (Serial) {
        url += `&Serial=${Serial.toUpperCase()}`;
      }
      if (ParentSerial) {
        url += `&ParentSerial=${ParentSerial.toUpperCase()}`;
      }
      if (KeySearch) {
        url += `&KeySearch=${KeySearch}`;
      }

      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        setData(response.data);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleCheckView = async (row: any) => {
    if (row.original.soHd == "3") {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.soHd}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-return-order", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.soHd,
            actionType: "view",
          },
        });
      }
    } else {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.soHd}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-order", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.soHd,
            actionType: "view",
          },
        });
      }
    }
  };

  useEffect(() => {
    const handleCheckView = async () => {};
    handleCheckView();
  }, []);

  const columns = React.useMemo<MRT_ColumnDef<reportItemSales>[]>(
    () => [
      //   {
      //     accessorKey: "id",
      //     header: "ID",
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      //   },
      {
        accessorKey: "parentSerial",
        header: "Serial cha",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "serial",
        header: "Serial con",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "itemCode",
        header: "Trạng thái serial con",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "atrribute2",
        header: "Mã nhập NCC",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 500,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "quantity",
        header: "Số lượng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "warrantyPeriod",
        header: "Bảo hành (tháng)",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      //   {
      //     accessorKey: "createBy",
      //     header: "Người tạo",
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      //   },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      //   {
      //     accessorKey: "lastUpdateBy",
      //     header: "Người cập nhật",
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue || "N/A"}</>,
      //   },
      //   {
      //     accessorKey: "lastUpdateDate",
      //     header: "Ngày cập nhật",
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      //   },
    ],
    [],
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["SoHd"],
        // right: ["tTienDh", "action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  // // Lấy danh sách mã chi nhánh
  // const DataBranchCode = async () => {
  //   try {
  //     const response = await repositoryDelivery.get(
  //       `api/v1/TblDmMasterOrg/get-select`
  //     );

  //     if (response && response.success) {
  //       const transformedData = response.data.map((item: any) => ({
  //         value: item.value,
  //         label: item.value + " - " + item.text,
  //       }));
  //       setDataBranchCode(transformedData);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return;
  //   }
  // };
  // Lấy danh sách kho
  const fetchDataKho = async () => {
    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmInventory/get-all?checkAuth=true`,
      );
      if (response && response.success) {
        const transformedData = response.data.map((item: any) => ({
          value: item.value,
          label: item.text,
        }));
        setDataInventory(transformedData);
      } else {
        setDataInventory([]);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Lấy danh sách mã bộ phận
  const fetchDataBp = async () => {
    try {
      if (
        userLogin &&
        userLogin.branchId !== null &&
        userLogin.branchId !== undefined
      ) {
        const response = await repositoryPos.get(
          `/api/v1/TblDepartment/get-all?branchId=${userLogin?.branchId}`,
        );
        if (response && response.success) {
          const transformedData = response.data.map((item: any) => ({
            value: String(item.deparmentCode),
            label: item.deparmentCode + " - " + item.name,
          }));
          setDataDepartment(transformedData);
        } else {
          setDataDepartment([]);
        }
      } else {
        const response = await repositoryPos.get(
          `/api/v1/TblDepartment/get-all`,
        );
        if (response && response.success) {
          const transformedData = response.data.map((item: any) => ({
            value: String(item.deparmentCode),
            label: item.deparmentCode + " - " + item.name,
          }));
          setDataDepartment(transformedData);
        } else {
          setDataDepartment([]);
        }
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const DataBranchCode = async () => {
    try {
      const response = await repositoryPos.get(
        `api/v1/TblDmInventory/get-select-branch?auth=true`,
      );
      if (response && response.success && response.data) {
        console.log("transformedData", response.data);
        const transformedData = response.data
          .filter(
            (branch: any) => branch.att2 !== null && branch.text !== "Tất cả",
          )
          .map((branch: any) => ({
            value: branch.att2,
            label: branch.att2 + " - " + branch.text,
          }));

        setDataBranchCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // Lấy danh sách mã khách hàng
  const fetchDataCustomer = async () => {
    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmCustomer/get-list?Skip=0&Take=100`,
      );
      if (response && response.success) {
        const transformedData = response.data
          .filter((item: any) => item.name !== null)
          .map((item: any) => ({
            value: String(item.id),
            label: String(item.code) + " - " + item.name,
          }))
          .filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex((t) => t.value === item.value),
          );

        setDataCustomer(transformedData);
      } else {
        setDataCustomer([]);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // Lưu key search
  useEffect(() => {
    const runAsyncFunctions = async () => {
      await SaveKeySearch(formSeachInput, null, 1);

      // localStorage.removeItem("allValueKeySearch");
    };
    const nextuse = async () => {
      await Promise.all([fetchDataBp(), DataBranchCode()]);
      await runAsyncFunctions();
      await fetchData();
    };
    nextuse();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const exportDataExcel = async () => {
    // // let params = new URLSearchParams();
    // // // Add the query parameters if they exist
    // // const keySearch = formSeachInput.getValues().keySearch;
    // // if (keySearch) {
    // //   params.append("KeySearch", keySearch);
    // // }
    // // const FromDate = formSeachInput.getValues().FromDate;
    // // if (FromDate) {
    // //   params.append("FromDate", FromDate);
    // // }
    // // const ToDate = formSeachInput.getValues().ToDate;
    // // if (ToDate) {
    // //   params.append("ToDate", ToDate);
    // // }
    // // const BranchCode = formSeachInput.getValues().BranchCode;
    // // if (BranchCode) {
    // //   params.append("BranchCode", BranchCode);
    // // }
    // let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
    //   pagination.pageSize
    // }`;
    // if (formSeachInput.getValues().keySearch) {
    //   url += `&KeySearch=${formSeachInput.getValues().keySearch}`;
    // }
    // if (formSeachInput.getValues().FromDate) {
    //   url += `&FromDate=${formatDateNotTimeZone(
    //     formSeachInput.getValues().FromDate
    //   )}`;
    // }
    // if (formSeachInput.getValues().ToDate) {
    //   url += `&ToDate=${formatDateNotTimeZone(
    //     formSeachInput.getValues().ToDate
    //   )}`;
    // }
    // if (formSeachInput.getValues().BranchCode) {
    //   url += `&BranchCode=${formSeachInput.getValues().BranchCode}`;
    // }
    // if (formSeachInput.getValues().DeparmentCode) {
    //   url += `&DeparmentCode=${formSeachInput.getValues().DeparmentCode}`;
    // }
    // const baseUrl = url.toString()
    //   ? `/api/v1/SaleByCustByOrder/export-excel?${url.toString()}`
    //   : `/api/v1/SaleByCustByOrder/export-excel`;
    // const _url = BASE_API_POS + baseUrl;
    // const fullUrl = new URL(_url);
    // const token = localStorage.getItem("token");
    // fetch(fullUrl.toString(), {
    //   method: "GET", // Use the appropriate HTTP method
    //   headers: {
    //     Authorization: `Bearer ${token?.replace(/"/g, "")}`,
    //     "Content-Type": "application/vnd.ms-excel",
    //   },
    // })
    //   .then((response) => {
    //     if (response.ok) {
    //       return response.blob(); // Assuming the response is a file or blob
    //     } else {
    //       throw new Error("Failed to fetch the resource");
    //     }
    //   })
    //   .then((blob) => {
    //     // Open the blob in a new tab
    //     const url = window.URL.createObjectURL(blob);
    //     let filename = "bao_cao_doanh_so_ban_hang.xlsx"; // Tên mặc định nếu không có header
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.download = filename;
    //     document.body.appendChild(link);
    //     link.click();
    //     link.remove();
    //     window.URL.revokeObjectURL(url);
    //   })
    //   .catch((error) => {
    //     console.error("Error:", error);
    //   });
  };
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Menu shadow="md" width={200}>
          <Menu.Target>
            <Button
              // size="xs"
              rightSection={
                <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
              }
            >
              Chức năng
            </Button>
          </Menu.Target>

          {/* <Menu.Dropdown>
            <Menu.Label>Application</Menu.Label>
            <Menu.Item
              leftSection={
                <IconFileExport style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Menu.Item>
          </Menu.Dropdown> */}
        </Menu>
      </Flex>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Mã Phiếu nhập hàng"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("Code")}
              {...formSeachInput.getInputProps("Code")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                  localStorage.setItem(
                    "allValueKeySearch",
                    JSON.stringify({
                      ...formSeachInput.getValues(),
                      url: String(window.location.pathname),
                    }),
                  );
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Serial con"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("Serial")}
              {...formSeachInput.getInputProps("Serial")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                  localStorage.setItem(
                    "allValueKeySearch",
                    JSON.stringify({
                      ...formSeachInput.getValues(),
                      url: String(window.location.pathname),
                    }),
                  );
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Serial cha"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("ParentSerial")}
              {...formSeachInput.getInputProps("ParentSerial")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                  localStorage.setItem(
                    "allValueKeySearch",
                    JSON.stringify({
                      ...formSeachInput.getValues(),
                      url: String(window.location.pathname),
                    }),
                  );
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá tìm kiếm"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                  localStorage.setItem(
                    "allValueKeySearch",
                    JSON.stringify({
                      ...formSeachInput.getValues(),
                      url: String(window.location.pathname),
                    }),
                  );
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
                localStorage.setItem(
                  "allValueKeySearch",
                  JSON.stringify({
                    ...formSeachInput.getValues(),
                    url: String(window.location.pathname),
                  }),
                );
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default ReportSerialChild;
